<template>
  <vx-card title="Mis Productos" code-toggler>
    <div class="vx-row">
      <div class="vx-col md:w-5/5 w-full mt-5">
          <vs-table pagination max-items="15" stripe search :data="listaProyectosProductos">
            <template slot="thead">
              <vs-th sort-key="macaddress">Macaddress</vs-th>
              <vs-th sort-key="proveedor">Proveedor</vs-th>
              <vs-th sort-key="producto">Producto</vs-th>
              <vs-th sort-key="puntos">VIVOCOINS</vs-th>
              <vs-th sort-key="fecha_garantia">Fecha Garantia</vs-th>
            </template>
            <template slot-scope="{data}">
              <vs-tr :data="tr" :key="index" v-for="(tr, index) in data">
                <vs-td :data="data[index].macaddress">
                  {{ data[index].macaddress }}
                </vs-td>
                <vs-td :data="data[index].proveedor">
                  {{ data[index].proveedor }}
                </vs-td>
                
                <vs-td :data="data[index].producto">
                  {{ data[index].producto }}
                </vs-td>

                <vs-td :data="data[index].puntos">
                  {{ data[index].puntos }}
                </vs-td>

                <vs-td :data="data[index].fecha_garantia">
                  {{ data[index].fecha_garantia }}
                </vs-td>

              </vs-tr>
            </template>
          </vs-table>
      </div>
    </div>
  </vx-card>  
</template>
<script>
import { FormWizard, TabContent } from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import 'sweetalert2/dist/sweetalert2.min.css';
import Datepicker from 'vuejs-datepicker'
import axios from '../../axios.js'
import vSelect from 'vue-select'
import Vue from 'vue'
import VueSweetalert2 from 'vue-sweetalert2';
Vue.use(VueSweetalert2);
Vue.component('v-select', vSelect)
import { Validator } from 'vee-validate'
export default {
  data () {
    return {
      listaProyectosProductos: [],
    }
  },
  methods: {
    VerProyectosProductos() {
      this.$vs.loading({type:'corners'});
      this.$http.post('Cargas','obtenerProductosEmpresa',{},(data)=>{
          this.listaProyectosProductos = data;
          this.$vs.loading.close();
      });
    },
  },
  components: {
    Datepicker,
    FormWizard,
    TabContent
  }, 
  mounted() {
    this.VerProyectosProductos();
  },
}
</script>